import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
Vue.use(Vuex);
const vuexPersist = new VuexPersist({
  key: "app-data-hrs",
  storage: window.sessionStorage,
});
export default new Vuex.Store({
  plugins: [vuexPersist.plugin],

  state: {
    user: null,
    userType: "",
    organization: "",
    sidebarMenus: [],
    cancelTokens: [], // axios cancel token
    clockInTime: null,
    clockedIn: false,
    routeTo: null,
    userRole: "",
    organizationDetails: null,
    employees: [],
    currentEmployeeId: "",
    currentJournalId: "",
    tabTitle: null,
    licencePricing: null,
    latestClockInTimeWithoutClockout: "",
    currentWorkflow: [],
    currentClaimWorkflow: [],
    profileCompletionRate: 0,
    countDown: 10,
    isLoading: false,
    refreshToken: "",
    isAppIdle: false,
    sessionIsExpired: false,
    reviewPeriod: ""
  },
  mutations: {
    setIsLoading(state, value) {
      state.isLoading = value;
    },

    resetState(state) {
      // Clear all state properties
      Object.keys(state).forEach((key) => {
        state[key] = null;
      });


    },

    // login the user
    login(state, token) {
      state.user = token;

    },
    setRefreshToken(state, refreshToken) {
      state.refreshToken = refreshToken
    },
    setProfileCompletionRate(state, rate) {
      state.profileCompletionRate = rate;
    },
    setUserToView(state, user) {
      state.userToview = user;
    },
    // set user type
    setUserType(state, type) {
      state.userType = type;
    },
    setCountDown(state, count) {
      state.countDown = count;
    },
    storeSidebarMenus(state, menus) {
      state.sidebarMenus = menus;
    },
    logout(state) {
      state.user = null;
      state.userToView = null;
      state.organizationDetails = null
    },
    setIsSessionpired(state, isExpired) {
      state.sessionIsExpired = isExpired;
    },
    setClockIn(state, time) {
      state.clockInTime = time;
      state.clockedIn = true;
    },
    clockOut(state) {
      state.clockedIn = false;
    },
    // clear axios cancel tokens
    clearCancelTokens(state) {
      state.cancelTokens = [];
    },
    // add axios cancel tokens
    addCancelTokens(state, token) {
      state.cancelTokens.push(token);
    },
    // add axios cancel tokens
    saveRouteTo(state, name) {
      state.routeTo = name;
    },
    // validate organization
    setOrganizationDetails(state, organization = null) {
      state.organizationDetails = organization;
      state.organization = organization;
    },
    setBase() {
      // state.base = base;
    },


    setIsAppIdle(state, value) {
      state.isAppIdle = value;
    },
    setEmployees(state, employees) {
      state.employees = employees;
    },
    setCurrentEmployeeId(state, employeeId) {
      state.currentEmployeeId = employeeId;
    },
    setCurrentJournalId(state, journalId) {
      state.currentJournalId = journalId;
    },
    setTabTitle(state, title) {
      state.tabTitle = title;
    },
    setLicencePricing(state, pricing) {
      state.licencePricing = pricing;
    },
    setProfilePicture(state, picture) {

      state.user.ProfilePicture = picture;

    },
    setLatestClockInTimeWithoutClockout(
      state,
      latestClockInTimeWithoutClockout
    ) {
      state.latestClockInTimeWithoutClockout = latestClockInTimeWithoutClockout;
    },
    setWorkflowToReview(state, workflow) {
      state.currentWorkflow = workflow;
    },
    setClaimWorkflowToReview(state, workflow) {
      state.currentClaimWorkflow = workflow;
    },
    setAccessTokenExpiresIn(state, expiresIn) {
      state.user.AccessTokenExpires = expiresIn;
    },
    setToken(state, token) {
      state.user.AccessToken = token;
    },
    setReviewPeriod(state, period) {
      state.reviewPeriod = period
    }
    // setClaimWorkflowToView
  },
  actions: {
    // clear pending requests
    cancelPendingRequests(context) {
      context.state.cancelTokens.forEach((request) => {
        if (request.cancel) {
          request.cancel();
        }
      });
      context.commit("clearCancelTokens");
    },

    logout(context) {
      localStorage.removeItem('app-data-hrs')
      // Clear all state properties
      context.commit("resetState");

      // Clear the persisted state
      vuexPersist.clear();


      // Redirect the user to the login page
      // context.dispatch("router/push", { name: `${this.getters.getOrganization}/login` });
    },
  },
  // store getters
  getters: {
    getIsLoading: (state) => state.isLoading,
    isAuthenticated: (state) => !!state.user,
    cancelTokens: (state) => state.cancelTokens,
    getToken: (state) => state.user.AccessToken,
    getUser: (state) => state.user,
    getRefreshToken: (state) => state.refreshToken,
    getAccessTokenExpiresIn: (state) => state.user.AccessTokenExpires,
    getProfileCompletionRate: (state) => state.profileCompletionRate,
    getClockInTime: (state) => state.clockInTime,
    isUseClockedIn: (state) => state.clockedIn,
    getUserType: (state) => state.userType,
    getUserRole: (state) => state.user ? state.user.Role : "",
    isPasswordChanged: (state) => state.user.PasswordChanged,
    getOrganizationDetails: (state) => state.organizationDetails,
    getisAppIdle: (state) => state.isAppIdle,
    getOrganization: (state) => {
      return state.organization?.OrganizationName
        ?.toLowerCase()
        .split(" ")
        .join("") || state.organizationDetails?.OrganizationName;
    },
    getOrganizationName: (state) => {
      return state.organizationDetails?.OrganizationName?.toLowerCase().split(" ").join("");
    },
    getBase: (state) => state.base,
    getFilteredMenu(state) {
      var menus = [];
      state.sidebarMenus.forEach((menu) => {
        if (menu.visibility.includes(state.userType)) {
          menus.push(menu);
        }
      });
      return menus;
    },
    getRouteTo: (state) => state.routeTo,
    getEmployees: (state) => state.employees,
    getCurrentEmployeeId: (state) => state.currentEmployeeId,
    getCurrentJournalId: (state) => state.currentJournalId,
    getTabTitle: (state) => state.tabTitle,
    getLicencePricing: (state) => state.licencePricing,
    getLatestClockInTimeWithoutClockout: (state) =>
      state.latestClockInTimeWithoutClockout,
    getCurrentWorkflow: (state) => state.currentWorkflow,
    getCurrentClaimWorkflow: (state) => state.currentClaimWorkflow,
    getUserToView: (state) => state.userToview,
    getCountDown: (state) => state.countDown,
    getOrganizationSetupCompletionRate: (state) => state.profileCompletionRate,
    getProfileCompletion: (state) => state.profileCompletionRate,
    getSessionIsExpired: (state) => state.sessionIsExpired,
    getReviewPeriod: (state) => state.reviewPeriod
  },
});
